import PropTypes from 'prop-types';
import React from 'react';
import { AvailabilityCalendar } from '../../Modules';
import onClickOutside from 'react-onclickoutside';

const DatePicker = class DatePicker extends React.Component {

  static propTypes = {
    month: PropTypes.object,
    selectedDay: PropTypes.object,
    updateSelectedDay: PropTypes.func,
    handleDayClick: PropTypes.func,
    close: PropTypes.func,
    style: PropTypes.object,
    viewer: PropTypes.object
  }

  handleClickOutside() {
    this.props.close();
  }

  render() {
    return (
      <div
        style={Object.assign({}, {
          position: 'absolute',
          top: 'calc(100% + 0.25em)',
          left: '0.5em',
          background: '#fff',
          border: '1px solid #ccc',
          zIndex: 100,
          padding: '1em'
        }, this.props.style)}
      >
        <AvailabilityCalendar
          closeOnSelect
          close={this.props.close}
          style={{ flex: 1 }}
          initialMonth={this.props.month}
          selectedDay={this.props.selectedDay}
          updateSelectedDay={this.props.updateSelectedDay}
          onDayClick={this.props.handleDayClick}
          viewer={this.props.viewer}
        />
      </div>
    );
  }
};

export default onClickOutside(DatePicker);



// WEBPACK FOOTER //
// ./webpack/components/Elements/CardField/DatePicker.js